import React from 'react';
import { VStack } from '@chakra-ui/react';
import { HeadingText, BodyText } from '@spotoninc/nexus-react';

export const RegistrationHeader = ({ title, description }) => {
  return (
    <VStack spacing={4} align="stretch">
      <HeadingText fontWeight="600" fontSize="500">
        {title}
      </HeadingText>
      <BodyText size="medium">{description}</BodyText>
    </VStack>
  );
};
